import script from "./PortalContentAndDesignInitializer.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalContentAndDesignInitializer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__